import { defineMessages } from 'react-intl';
import './theme.css';
import type { AgentLogo } from '@/app/lib/stage/StageHeader.tsx';
import type { MessageDescriptor } from 'react-intl';

const siteMessages = defineMessages({
  askPlaceholder: {
    id: 'composer.businessPrompt',
    defaultMessage: 'Describe the idea you are trying to shape…',
    description: 'Invitation shown inside the empty composer.',
  },
});

export interface SiteConfig {
  brandName: string;
  /** Optional logo, omitted because this fictional demo has no supplied logo asset. */
  logo?: AgentLogo;
  /** The assistant's appearance. 'auto' follows the visitor's OS. */
  appearance: 'light' | 'dark' | 'auto';
  /** Omnibox placeholder override. */
  placeholder?: MessageDescriptor;
  /** Hide browser voice controls and do not mount the voice surface. */
  voiceEnabled: boolean;
}

export const SITE_CONFIG: SiteConfig = {
  brandName: 'BriefForge by Gearz',
  appearance: 'dark',
  placeholder: siteMessages.askPlaceholder,
  voiceEnabled: false,
};
